import React from "react";
// import SyncLoader from "react-spinners/SyncLoader";
import PulseLoader from "react-spinners/PulseLoader";
import ScaleLoader from "react-spinners/ScaleLoader";

function Loader({ loading, color, fullPage = false }) {
  const typeLoader = fullPage ? fullPage : false;
  return (
    <>
      {typeLoader && loading ? (
        <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center z-[9999] bg-black/30 backdrop-blur-[2px]">
          <ScaleLoader
            color="#5061B2"
            size={16}
            speedMultiplier={1}
            loading={loading}
          />
        </div>
      ) : (
        <PulseLoader
          color={color}
          size={8}
          speedMultiplier={1}
          loading={loading}
        />
      )}
    </>
  );
}

export default Loader;
